module.exports = __webpack_public_path__ + "img/device-windows-mobile-b366cfe9a5b2aeec3743a3d353d57689.svg";